import GeneratedAddressBookServiceApi from "./generated/GeneratedAddressBookServiceApi"

class AddressBookServiceApi extends GeneratedAddressBookServiceApi {

}

export const addressBookServiceApi = new AddressBookServiceApi()
